<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item "><router-link :to="getHomePath()">Home</router-link></li>
        <li v-if="userIsAdmin" class="breadcrumb-item "><router-link :to="getEditMenuPath(menu.id)">Edici&oacute;n de menú web</router-link></li>
        <li class="breadcrumb-item "><router-link :to="getListMenuItemsPath(menu.id)">Listado de elementos del menú</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">
          <span v-if="item.id">Edici&oacute;n de elemento de menú</span>
          <span v-else>Creación de elemento de menú</span>
        </li>
      </ol>
    </nav>
    <draf-message @draft_resolved="initMenu()" :menu="menu" />
    <div class="text-center text-center layer-button">
      <button type="button" @click="sendData" class="btn btn-primary" :disabled='waiting'>
        <span v-if="waiting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Enviar
      </button>
    </div>
    <div class="container-fluid">
      <div v-if="successMessage" class="alert alert-success" role="alert">
        {{ successMessage }}
      </div>
      <div v-if="errorMessages.length" class="alert alert-danger" role="alert">
        <p v-for="message in errorMessages">{{ message }}</p>
      </div>
      <div class="contact-form">
        <h2 v-if="item.id" class="text-center">Edici&oacute;n de elemento de menú</h2>
        <h2 v-else class="text-center">Creación de elemento de menú</h2>
        <form class="form-horizontal">
          <div class="row">
            <div class="col">
              <!-- Nombre -->
              <label for="name" class="font-weight-bold">Nombre</label>
              <input
                  class="form-control"
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Nombre"
                  :value="item.name"
                  @change="onNameUpdate($event)"
              >
              <div id="nameHelp" class="form-text">{{ nameText }}</div>
            </div>
          </div>
          <div class="form-group">
            <!-- CSS class -->
            <label for="css_class" class="font-weight-bold">Clase CSS Marketing</label>
            <input
                class="form-control"
                type="text"
                id="css_class"
                name="css_class"
                placeholder="Clase CSS"
                :value="item.css_class"
                @change="onCssClassUpdate($event)"
            >
            <div id="cssClassHelp" class="form-text">{{ cssClassText }}
              Lo recomendable es que contenga el prefijo 'menu_item_' y un texto descriptivo. Ejemplo para la home de hoteles: 'menu_item_hotels'.</div>
          </div>
          <div class="row">
            <div class="col">
              <label for="mobile" class="font-weight-bold">Mobile</label>
              <div>
                <toggle-switch
                    @update="onMobileUpdate"
                    name="mobile"
                    id="mobile"
                    :checked="mobileIsChecked"
                />
              </div>
              <div id="mobileHelp" class="form-text">{{ mobileText }}</div>
            </div>
            <div class="col">
              <label for="tablet" class="font-weight-bold">Tablet</label>
              <div>
                <toggle-switch
                    @update="onTabletUpdate"
                    name="tablet"
                    id="tablet"
                    :checked="tabletIsChecked"
                />
              </div>
              <div id="tabletHelp" class="form-text">{{ tabletText }}</div>
            </div>
            <div class="col">
              <label for="desktop" class="font-weight-bold">Desktop</label>
              <div>
                <toggle-switch
                    @update="onDesktopUpdate"
                    name="desktop"
                    id="desktop"
                    :checked="desktopIsChecked"
                />
              </div>
              <div id="desktopHelp" class="form-text">{{ desktopText }}</div>
            </div>
            <div class="col">
              <label for="no_follow" class="font-weight-bold">No follow</label>
              <div>
                <toggle-switch
                    @update="onNoFollowUpdate"
                    name="no_follow"
                    id="no_follow"
                    :checked="onFollowIsChecked"
                />
              </div>
              <div id="noFollowHelp" class="form-text">{{ noFollowText }}</div>
            </div>
            <div class="col">
              <label for="target_blank" class="font-weight-bold">Target blank</label>
              <div>
                <toggle-switch
                    @update="onTargetBlankUpdate"
                    name="target_blank"
                    id="target_blank"
                    :checked="onTargetBlankIsChecked"
                />
              </div>
              <div id="targetBlankHelp" class="form-text">{{ targetBlankText }}</div>
            </div>
            <div class="col">
              <label for="is_disabled" class="font-weight-bold">¿Está Desactivado?</label>
              <div>
                <toggle-switch
                    @update="onIsDisabledUpdate"
                    name="is_disabled"
                    id="is_disabled"
                    :checked="onIsDisabledUpdateIsChecked"
                />
              </div>
              <div id="isDisabledHelp" class="form-text">{{ isDisabledText }}</div>
            </div>
            <div class="col" v-if="userIsAdmin">
              <label for="is_admin_reserved" class="font-weight-bold">Reservado para admin</label>
              <div>
                <toggle-switch
                    @update="onIsAdminReservedUpdate"
                    name="is_admin_reserved"
                    id="is_admin_reserved"
                    :checked="onIsAdminReservedIsChecked"
                />
              </div>
              <div id="isAdminReservedHelp" class="form-text">{{ isAdminReservedText }}</div>
            </div>
          </div>
          <div class="form-group" style="margin-top: 40px;">
            <h4>Textos + URLs</h4>
            <!-- Textos + URLs -->
            <label for="texts_urls" class="font-weight-bold">Textos y URLs del elemento que se mostrarán en diferentes idiomas:</label>
            <div class="row" v-for="(value, key) in languages" style="margin-top: 10px;">
              <div class="col-2">
                {{ value }}
              </div>
              <div class="col">
                <input
                    class="form-control"
                    type="text"
                    :id="'texts_' + key"
                    :name="'texts_' + key"
                    :placeholder="'Texto en ' + value"
                    :value="getItemLanguageValue(key, 'text')"
                    @change="onTextUpdate($event)"
                >
              </div>
              <div class="col">
                <input
                    class="form-control"
                    type="text"
                    :id="'urls_' + key"
                    :name="'urls_' + key"
                    :placeholder="'URL para ' + value"
                    :value="getItemLanguageValue(key, 'url')"
                    @change="onUrlUpdate($event)"
                >
              </div>
            </div>
            <div id="textsUrlsHelp" class="form-text">El obligatorio introducir datos en al menos un idioma.</div>
          </div>
          <div class="form-group" style="margin-top: 40px;">
            <h4>Origen del cliente</h4>
            <div class="row">
              <div class="col">
                <!-- Pais del cliente -->
                <label for="user_country" class="font-weight-bold">{{ userCountryText }}</label>
                <user-country-selector
                    @error="onComponentError"
                    @update="onUserCountryUpdate"
                    :selectedValues="item.origin_countries"
                    id='user_country'
                    name='user_country'
                    label="name"
                    trackBy="id"
                    placeholder='Selecciona paises'
                />
                <div id="userCountryHelp" class="form-text">Si no se selecciona ningún país no se tiene en cuenta el origen del cliente.</div>
              </div>
              <div class="col-2 my-auto">
                <button type="button" @click="setAllUserCountries" class="btn btn-primary">
                  Añadir todos
                </button>
                <button type="button" @click="removeUserCountries" class="btn btn-primary" style="margin-top: 10px;">
                  Quitar todos
                </button>
              </div>
            </div>
          </div>
          <div class="form-group" style="margin-top: 40px;">
            <h4>Periodos de validez</h4>
            <!-- Periodos de validez -->
            <label for="dates" class="font-weight-bold">{{ validDatesText }}</label>
            <div class="row" v-for="n in numMaxValidDates">
              <div class="col">
                <label for="target_blank" class="font-weight-bold">{{ n }}. Desde</label>
                <date-picker placeholder="Selecciona fecha desde" :name="'from_date_' + n" @update="onFromDateUpdate" :selectedValue="getItemDateValue(n, 'from')" />
              </div>
              <div class="col">
                <label for="target_blank" class="font-weight-bold">Hasta</label>
                <date-picker placeholder="Selecciona fecha hasta" :name="'to_date_' + n" @update="onToDateUpdate" :selectedValue="getItemDateValue(n, 'to')"/>
              </div>
            </div>
            <div id="datesHelp" class="form-text">De manera opcional se pueden seleccionar hasta 4 periodos de fechas.</div>
          </div>

          <div class="row" style="margin-top: 40px;">
            <h4>Personalización del elemento</h4>
            <div class="col">
              <!-- Clase CSS contenedor -->
              <label for="name" class="font-weight-bold">Clase CSS contenedora</label>
              <input
                  class="form-control"
                  type="text"
                  id="container_class"
                  name="container_class"
                  placeholder="Clase CSS contenedora"
                  :value="item.container_class"
                  @change="onContainerClassUpdate($event)"
              >&nbsp;
              <div id="containerClassHelp" class="form-text">{{ containerClassText }}</div>
            </div>
            <div class="col">
              <!-- Id seccion -->
              <label for="name" class="font-weight-bold">Id de sección</label>
              <input
                  class="form-control"
                  type="text"
                  id="section_id"
                  name="section_id"
                  placeholder="Id de sección"
                  :value="item.section_id"
                  @change="onSectionIdUpdate($event)"
              >&nbsp;
              <div id="sectionIdHelp" class="form-text">{{ sectionIdText }}</div>
            </div>
            <div class="col">
              <!-- Id subseccion -->
              <label for="name" class="font-weight-bold">Id de subsección</label>
              <input
                  class="form-control"
                  type="text"
                  id="sub_section_id"
                  name="sub_section_id"
                  placeholder="Id de subsección"
                  :value="item.sub_section_id"
                  @change="onSubSectionIdUpdate($event)"
              >&nbsp;
              <div id="subSectionIdHelp" class="form-text">{{ subSectionIdText }}</div>
            </div>
          </div>

          <div class="row" style="margin-top: 40px;">
            <h4>Contenido HTML opcional del elemento</h4>
            <div class="row">
              <div class="col">
                <!-- HTML -->
                <label for="html" class="font-weight-bold">Código HTML</label>
                <text-area
                    @update="onHtmlUpdate"
                    name="html"
                    id="html"
                    rows="4"
                    :selectedValue="item.html"
                />
                <div id="htmlHelp" class="form-text">{{ htmlText }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <!-- comportamiento HTML -->
                <label for="type" class="font-weight-bold">Comportamiento del contenido HTML</label>
                <html-behaviour
                    @update="onHtmlBehaviourUpdate"
                    :selectedValue="item.html_behaviour"
                />
                <div id="htmlBehaviourHelp" class="form-text">{{ htmlBehaviourText }}</div>
              </div>
            </div>
          </div>

          <div class="text-center text-center layer-button">
            <button type="button" @click="sendData" class="btn btn-primary" :disabled='waiting'>
              <span v-if="waiting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Enviar
            </button>
          </div>
        </form>
      </div>
      <div v-if="isDevServer"><pre>{{ item }}</pre></div>
      <div v-if="isDevServer"><pre>{{ menu }}</pre></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Language from '@/utils/Language.js'
import HelpTexts from '@/utils/HelpTexts.js'
import BaseMenuView from '@/views/BaseMenuView.vue'
import MenuValidator from '@/validators/MenuValidator.js'
import ToggleSwitch from '@/components/Form/ToggleSwitch.vue'
import Textarea from '@/components/Form/Textarea.vue'
import UserCountrySelector from '@/components/Form/UserCountrySelector.vue'
import Datepicker from '@/components/Form/DatePicker.vue'
import VueScrollTo from 'vue-scrollto';
import DrafMessage from '@/components/DrafMessage.vue'
import Country from '@/utils/Country.js'
import HtmlBehaviour from '@/components/Form/HtmlBehaviourSelector.vue'

export default {
  name: 'edit-menu',
  extends: BaseMenuView,
  props: {
    numMaxValidDates: {
      type: Number,
      default: 4
    },
  },
  data () {
    return {
      item : {},
    };
  },
  components: {
    'toggle-switch' : ToggleSwitch,
    'text-area' : Textarea,
    'user-country-selector' : UserCountrySelector,
    'date-picker' : Datepicker,
    'draf-message' : DrafMessage,
    'html-behaviour' : HtmlBehaviour,
  },
  computed: {
    nameText: function () {
      return HelpTexts.getItemNameText();
    },
    containerClassText: function () {
      return HelpTexts.getItemContainerClassText();
    },
    sectionIdText: function () {
      return HelpTexts.getItemSectionIdTextText();
    },
    subSectionIdText: function () {
      return HelpTexts.getItemSubSectionIdText();
    },
    cssClassText: function () {
      return HelpTexts.getItemCssClassText();
    },
    htmlText: function () {
      return HelpTexts.getItemHtmlText();
    },
    htmlBehaviourText: function () {
      return HelpTexts.getItemHtmlBehaviourText();
    },
    mobileText: function () {
      return HelpTexts.getItemMobileText();
    },
    tabletText: function () {
      return HelpTexts.getItemTabletText();
    },
    desktopText: function () {
      return HelpTexts.getItemDesktopText();
    },
    noFollowText: function () {
      return HelpTexts.getItemNoFollowText();
    },
    targetBlankText: function () {
      return HelpTexts.getItemTargetBlankText();
    },
    userCountryText: function () {
      return HelpTexts.getItemUserCountryText();
    },
    validDatesText: function () {
      return HelpTexts.getItemValidDatesText();
    },
    isAdminReservedText: function () {
      return HelpTexts.getItemIsAdminReservedText();
    },
    isDisabledText: function () {
      return HelpTexts.getItemIsDisabledText();
    },
    mobileIsChecked: function () {
      return this.item.mobile === '1';
    },
    tabletIsChecked: function () {
      return this.item.tablet === '1';
    },
    desktopIsChecked: function () {
      return this.item.desktop === '1';
    },
    onFollowIsChecked: function () {
      return this.item.no_follow === '1';
    },
    onTargetBlankIsChecked: function () {
      return this.item.target_blank === '1';
    },
    onIsAdminReservedIsChecked: function () {
      return this.item.is_admin_reserved === '1';
    },
    onIsDisabledUpdateIsChecked: function () {
      return this.item.is_disabled === '1';
    },
    languages: function () {
      return Language.getLanguages();
    },
  },
  methods: {
    sendData () {
      this.item.web_menu_id = this.menu.id;
      if (this.validateMenuItem()) {
        if (this.item.id) {
          this.updateItemMenu();
        } else {
          this.createItemMenu();
        }
      }
      this.scrollToTop();
    },
    validateMenuItem () {
      this.successMessage = '';
      this.errorMessages = MenuValidator.validateItem(this.item);
      return this.errorMessages.length == 0;
    },
    createItemMenu() {
      this.waiting = true;
      this.item.position = this.getDefaultPosition();
      axios
          .post(this.getMenuItemUrl(), this.item)
          .then(response => {
            if (response.data.result) {
              this.item = response.data.data;
              this.initMenu();
              this.successMessage = "Elemento de menú creado correctamente";
            } else {
              this.errorMessages.push("Se ha producido un error al crear el elemento de menú.");
            }
          }).catch(() => {
        this.errorMessages.push("Se ha producido un error al crear el elemento de menú.");

      }).finally(() => {
        this.waiting = false;
      });
    },
    updateItemMenu() {
      this.waiting = true;
      axios
          .put(this.getMenuItemUrl(), this.item)
          .then(response => {
            if (response.data.result) {
              this.initMenu();
              this.successMessage = "Elemento de menú actualizado correctamente";
            } else {
              this.errorMessages.push("Se ha producido un error al actualizar el elemento de menú.");
            }
          }).catch(() => {
        this.errorMessages.push("Se ha producido un error al crear el elemento de menú.");
      }).finally(() => {
        this.waiting = false;
      });
    },
    onComponentError (message) {
      this.errorMessages.push(message);
    },
    onNameUpdate (event) {
      this.item.name = event.target.value;
    },
    onContainerClassUpdate (event) {
      this.item.container_class = event.target.value;
    },
    onSectionIdUpdate (event) {
      this.item.section_id = event.target.value;
    },
    onSubSectionIdUpdate (event) {
      this.item.sub_section_id = event.target.value;
    },
    onCssClassUpdate (event) {
      this.item.css_class = event.target.value;
    },
    onHtmlUpdate (value) {
      this.item.html = value;
    },
    onHtmlBehaviourUpdate (value) {
      this.item.html_behaviour = value;
    },
    onTargetBlankUpdate (value) {
      this.item.target_blank = value ? '1' : '0';
    },
    onNoFollowUpdate (value) {
      this.item.no_follow = value ? '1' : '0';
    },
    onDesktopUpdate (value) {
      this.item.desktop = value ? '1' : '0';
    },
    onMobileUpdate (value) {
      this.item.mobile = value ? '1' : '0';
    },
    onTabletUpdate (value) {
      this.item.tablet = value ? '1' : '0';
    },
    onIsAdminReservedUpdate (value) {
      this.item.is_admin_reserved = value ? '1' : '0';
    },
    onIsDisabledUpdate(value) {
      this.item.is_disabled = value ? '1' : '0';
    },
    onUserCountryUpdate (values) {
      let countries = [];
      if (Array.isArray(values)) {
        values.forEach(function (country_id) {
          countries.push(country_id);
        });
      }
      this.item.origin_countries = countries;
    },
    onFromDateUpdate(value) {
      this.setItemValidDateValue(value, 'from');
    },
    onToDateUpdate(value) {
      this.setItemValidDateValue(value, 'to');
    },
    onTextUpdate(event) {
      this.setItemLanguageValue(event.target.name, event.target.value, 'text');
    },
    onUrlUpdate(event) {
      this.setItemLanguageValue(event.target.name, event.target.value, 'url');
    },
    initMenuItem() {
      this.item = this.getDefaultMenuItem();
      if (this.$route.params.itemId) {
        this.waiting = true;
        let params = {};
        params['id'] = this.$route.params.itemId;
        axios
            .get(this.getMenuItemUrl(), {params: params})
            .then(response => {
              if (response.data.result) {
                this.item = response.data.data;
              } else {
                this.errorMessages.push("Se ha producido un error al consultar el elemento del menú.");
              }
            }).catch(() => {
          this.errorMessages.push("Se ha producido un error al consultar el elemento del menú.");

        }).finally(() => {
          this.waiting = false;
          this.$nextTick(() => {
            VueScrollTo.scrollTo('nav');
          });
        });
      } else {
        this.$nextTick(() => {
          VueScrollTo.scrollTo('nav');
        });
      }
    },
    setAllUserCountries() {
      let countries = [];
      for (const [key, value] of Object.entries(Country.getCountries())) {
        countries.push(key);
      }
      this.item.origin_countries = countries;
    },
    removeUserCountries() {
      this.item.origin_countries = [];
    },
    getDefaultMenuItem() {
      return {
        "id": "",
        "web_menu_id": 0,
        "name": "",
        "container_class": "",
        "position": 0,
        "css_class": "",
        "section_id": "",
        "sub_section_id": "",
        "html": "",
        "html_behaviour": "",
        "mobile": 0,
        "tablet": 0,
        "desktop": 0,
        "no_follow": 0,
        "target_blank": 0,
        "is_disabled": 0,
        "is_admin_reserved": 0,
        "origin_countries" : [],
        "valid_dates" : [],
        "langs" : {}
      };
    },
    getDefaultPosition() {
      let position = 1;
      if (this.menu && this.menu.items && this.menu.items.length) {
        position = this.menu.items.length + 1;
      }
      return position;
    },
    setItemValidDateValue(value, type) {
      for (let key = 0; key < this.numMaxValidDates; key ++) {
        if (!this.item.valid_dates[key]) {
          this.item.valid_dates[key] = {'from' : '', 'to' : ''};
        }
      }
      let date_index = parseInt(value.name.replace(type + '_date_', '')) - 1;
      if (value.value) {
        const date_items = value.value.split("-");
        let date = new Date(date_items[0], date_items[1], date_items[2]);
        this.item.valid_dates[date_index][type] = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      } else {
        this.item.valid_dates[date_index][type] = "";
      }
    },
    setItemLanguageValue(name, value, type) {
      let lang = name.replace(type + 's_', '');
      if (!this.item.langs[lang]) {
        this.item.langs[lang] = {'text' : '', 'url' : ''};
      }
      this.item.langs[lang][type] = value;
      if (!this.item.langs[lang]['text'] && !this.item.langs[lang]['url']) {
        delete this.item.langs[lang];
      }
    },
    scrollToTop() {
      VueScrollTo.scrollTo('nav');
    },
    getItemDateValue: function (key, type) {
      let date = "";
      let date_key = key - 1;
      if (this.item.valid_dates && this.item.valid_dates[date_key] && this.item.valid_dates[date_key][type]) {
        date = this.item.valid_dates[date_key][type];
      }
      return date;
    },
    getItemLanguageValue: function (key, type) {
      let value = "";
      if (this.item.langs && this.item.langs[key] && this.item.langs[key][type]) {
        value = this.item.langs[key][type];
      }
      return value;
    },
  },
  created () {
    this.initMenu();
    this.initMenuItem();
  },
}
</script>

<style>
.form-horizontal{
  display:block;
  width:50%;
  margin:0 auto;
}
</style>
